"use client";

import { useEffect } from "react";
import { reportBoundaryError } from "@/lib/observability/report-boundary-error";

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    reportBoundaryError(error, "global");
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div
          data-testid="booking-error-boundary"
          style={{
            display: "flex",
            minHeight: "100vh",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            padding: "1rem",
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontSize: "1.25rem", fontWeight: 600 }}>Something went wrong</h2>
          <p style={{ fontSize: "0.875rem", color: "#666", maxWidth: "28rem" }}>
            Try again in a moment. Going home will not book or change an
            appointment.
          </p>
          {error.digest ? (
            <p style={{ fontSize: "0.75rem", color: "#666" }}>
              Support reference: <span data-testid="support-reference">{error.digest}</span>
            </p>
          ) : null}
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <button
              type="button"
              onClick={reset}
              style={{
                padding: "0.5rem 1rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                borderRadius: "0.375rem",
                cursor: "pointer",
              }}
            >
              Try again
            </button>
            <a
              href="/"
              style={{
                padding: "0.5rem 1rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                backgroundColor: "#fff",
                color: "#000",
                border: "1px solid #000",
                borderRadius: "0.375rem",
                textDecoration: "none",
              }}
            >
              Go to home
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
